<header id="home">
    <app-menu></app-menu>
    <app-banner></app-banner>
</header>
<app-about-us id="us" (values)="onShowVlues()"></app-about-us>
<app-coustumers></app-coustumers>
<app-briefcase id="briefcase"></app-briefcase>
<app-contact id="contact"></app-contact>
<cookie-law></cookie-law>